import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { request } from '../../Utils/request';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import TopNavBar from '../../Components/TopNavigation/TopNavBar';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 10) {
      setPhoneNumber(value);
      setError(null);
      setSuccess(null);
    }
  };

  const isPhoneNumberValid = phoneNumber.length === 10;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      const fullPhoneNumber = `+91${phoneNumber}`;
      const res = await request<any, { phoneNumber: string }>('/auth/forgot-password/request', {
        method: 'POST',
        body: { phoneNumber: fullPhoneNumber },
      });

      if (res.message || res.success) {
        // Navigate to OTP screen with phone number
        navigate('/forgot-password/otp', { 
          state: { phoneNumber: fullPhoneNumber } 
        });
      } else {
        setSuccess('OTP has been sent to your phone number.');
      }
    } catch (error: any) {
      setError(error.message || 'Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TopNavBar title="Forgot Password" canGoBack={true} />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#ffffff', minHeight: '100vh', padding: '16px' }}>
        <Box 
          style={{ width: '100%' }}
        >
          {/* Heading */}
          <Typography variant="h5" align="center" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
            Reset your password
          </Typography>

          {/* Instructional Text */}
          <Typography variant="subtitle1" align="center"  sx={{ mb: 3, color: 'text.secondary' }}>
          We'll send a reset OTP to your registered phone number
          </Typography>
          

          {/* Phone Number Input Form */}
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <TextField 
              name="phoneNumber" 
              label="Phone Number" 
              type="tel" 
              value={phoneNumber} 
              onChange={handleChange} 
              required 
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    +91
                  </InputAdornment>
                ),
              }}
            />
            <Typography variant="subtitle1" align="center"  sx={{  color: 'text.secondary' }}>
            Enter your 10-digit mobile number (Indian number only)
          </Typography>

            <Button 
              type="submit" 
              variant="contained" 
              style={{ 
                marginTop: 8, 
                backgroundColor: '#FF6B35', 
                textTransform: 'none', 
                borderRadius: 8, 
                fontWeight: 600,
                padding: '12px 16px' 
              }} 
              fullWidth
              disabled={loading || !isPhoneNumberValid}
            >
              {loading ? 'Sending...' : 'Send Verification Code'}
            </Button>
          </form>

          {success && <Alert severity="success" style={{ marginTop: 16 }}>{success}</Alert>}
          {error && <Alert severity="error" style={{ marginTop: 16 }}>{error}</Alert>}
        </Box>
      </div>
    </>
  );
};

export default ForgotPassword;

